export default __webpack_public_path__ + "static/media/C3.d808103d.svg";